import { Component } from 'react';
// @ts-expect-error Could not find declaration for module ...
import PreviewTextField from 'EmailDragDropEditorUI/components/settings/PreviewTextField';
import { GeneratePreviewTextProvider } from 'EmailEditorUI/context/GeneratePreviewTextContext';
import FromFields from 'EmailDragDropEditorUI/components/settings/FromFields';
// @ts-expect-error Could not find declaration for module ...
import SubjectFieldContainer from 'EmailDragDropEditorUI/containers/settings/SubjectFieldContainer';
import { GenerateSubjectLineProvider } from 'EmailDragDropEditorUI/components/settings/GenerateSubjectLineButton/GenerateSubjectLineContext';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class EmailDetailsContent extends Component {
  render() {
    return /*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "300",
      children: [/*#__PURE__*/_jsx(FromFields, {}), /*#__PURE__*/_jsxs(View, {
        inlineSize: "100%",
        maxInlineSize: "700px",
        children: [/*#__PURE__*/_jsx(GenerateSubjectLineProvider, {
          children: /*#__PURE__*/_jsx(SubjectFieldContainer, {})
        }), /*#__PURE__*/_jsx(GeneratePreviewTextProvider, {
          children: /*#__PURE__*/_jsx(PreviewTextField, {})
        })]
      })]
    });
  }
}